export default "__VITE_ASSET__D0tM4MyO__"